import configData from '../../config.json';
import httpClient from './httpClient';
import { getApiLanguage } from '../../utils/app/language';

export async function fetchTranslations(token, rmc) {
  const response = await httpClient.get('/Translations', {
    token,
    query: {
      language: getApiLanguage(),
      rmc,
      'subscription-key': configData.subscriptionkey,
    },
    responseType: 'json',
  });

  return response.data;
}
